/** @jsxImportSource theme-ui */
import { jsx } from "theme-ui";
import { Heading, Flex, Box, Text } from "@theme-ui/components";
import { Accordion } from "@greythr/shared-components";
import { colors, typography } from "@greythr/shared-components";

const FAQSection = ({
  faqList,
  backgroundColor = colors.secondaryGreen100,
  borderColor = colors.secondaryGreen400,
  iconColor = colors.secondaryGreenMain,
}) => {
  if (!faqList?.length) return null;

  const styles = getStyles(backgroundColor, borderColor);

  return (
    <Flex sx={styles} id="feature-faq">
      <Accordion>
        {faqList.map(({ question, answer }, index) => (
          <Box
            as="h3"
            label={question}
            key={`faq-${index}`}
            iconColor={iconColor}
            showChevronIcon
          >
            <Box
              sx={{ mt: "2rem", ...typography.textMd400, p: { m: 0 } }}
              dangerouslySetInnerHTML={{ __html: answer }}
            />
          </Box>
        ))}
      </Accordion>
    </Flex>
  );
};

const getStyles = (backgroundColor, borderColor) => ({
  width: ["100%", "100%", "100%", "100%"],
  flexDirection: "column",
  ".accordion-label": {
    ...typography.h5,
  },
  ".accordion-section": {
    padding: `1.5rem`,
    borderRadius: "1rem",
    backgroundColor: backgroundColor,
    transition: "background-color 0.1s ease",
    "&.open": {
      backgroundColor: colors.white,
      border: `1px solid ${borderColor}`,
    },
  },
  ".accordion-container": {
    display: "flex",
    flexDirection: "column",
    gap: 1,
  },
  ".accordion-heading": {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
});

export default FAQSection;
